module.exports = __webpack_public_path__ + "img/Pact.97556e13.png";